const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * VIRTUAL TRY-ON EVENTS                                                      *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.virtualTryOnClicked, () => {
    pushEvent(createCustomEventGA4('try_on', [['action', 'click']]));
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
